import {
	ReactElement,
	useCallback,
	useState
} from "react";
import {
	Button,
	Dialog,
	Toolbar
} from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { navigateToUriInPopOutWindow } from "client_legacy/ndaw/navigator";
import styles from "./AuthenticationRequiredDialog.module.less";
import { useDataInputDialog } from "client/Hooks";

export type OAuth2AuthenticationRequiredDialogProps = {
	redirectUrl: string;
	onClose(): void;
	onFinish(): void;
};

export const OAuth2AuthenticationRequiredDialog = (props: OAuth2AuthenticationRequiredDialogProps): ReactElement => {
	const {
		redirectUrl,
		onFinish,
		onClose
	} = props;

	const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

	const clickHandler = useCallback(
		(): void => {
			navigateToUriInPopOutWindow(redirectUrl);
			setIsAuthenticated(true);
		},
		[redirectUrl]
	);

	return (
		<Dialog trackingId="authentication-required-dialog">
			<Dialog.Header
				title={localize("_AuthenticationRequired")}
			/>
			<Dialog.Body>
				<p className={styles.text}>
					{localize("_ToCompleteTheConfigurationAuthenticationIsNeededInfo")}
				</p>
				<div>
					<Button
						kind="primary"
						text={localize("_Authenticate")}
						onClick={clickHandler}
						trackingId="authenticate"
					/>
				</div>
			</Dialog.Body>
			<Dialog.Footer>
				<Toolbar>
					<Toolbar.Button
						kind="primary"
						text={localize("_Finish")}
						onClick={onFinish}
						isDisabled={!isAuthenticated}
						trackingId="finish"
					/>
					<Toolbar.Button
						kind="secondary"
						text={localize("_Cancel")}
						onClick={onClose}
						trackingId="cancel"
					/>
				</Toolbar>
			</Dialog.Footer>
		</Dialog>
	);
};
OAuth2AuthenticationRequiredDialog.displayName = "OAuth2AuthenticationRequiredDialog";

type InitialOAuth2AuthenticationRequiredDialogProps = Omit<OAuth2AuthenticationRequiredDialogProps, "onClose" | "onFinish">;

export function useOAuth2AuthenticationRequiredDialog(): [
	element: ReactElement | null,
	open: (props: InitialOAuth2AuthenticationRequiredDialogProps) => Promise<TryResult<void>>
] {
	return useDataInputDialog(
		(props, onClose, onSave) => (
			<OAuth2AuthenticationRequiredDialog
				{...props}
				onFinish={onSave}
				onClose={onClose}
			/>
		)
	);
}